import { useMediaAdCampaignPromosUpdateMutation } from '@shared/api/graphql/generated';
import { FetchPolicyKeys } from '@shared/api/graphql/types';
import { serializePromoAdInputs } from '../lib/serializePromoAdInputs';
import type { UseAdCampaignPromoUploadType } from './useAdPromosUpdate';

const useAdPromosSave = (): UseAdCampaignPromoUploadType => {
  const [mutate, result] = useMediaAdCampaignPromosUpdateMutation({ fetchPolicy: FetchPolicyKeys.NETWORK_ONLY });
  const request: UseAdCampaignPromoUploadType[0] = async (adCompanyId, promos) => {
    const response = await mutate({ variables: { input: { adCompanyId, adPromos: serializePromoAdInputs(promos) } } });
    return response.data?.result?.ok === true && !response.errors?.length;
  };
  return [request, { loading: result.loading, called: result.called, error: result.error }];
};

export default useAdPromosSave;
